import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { useTheme } from "../../theme/ThemeContext";

export default function Login() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { theme, toggleTheme } = useTheme();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const res = await fetch(
                "https://appel.amservices.eu/api/login.php",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ username, password }),
                }
            );

            const data = await res.json();

            if (data.success) {
                localStorage.setItem("authToken", data.token);
                localStorage.setItem("userRole", data.user.role);
                window.location.href = "/depannage";
            } else {
                setError("Identifiants incorrects");
            }
        } catch (err) {
            setError("Erreur de connexion serveur");
        }
    };

    return (
        <div className="login-container">
            <button
                type="button"
                className="login-theme-toggle"
                onClick={toggleTheme}
                aria-label={theme === "dark" ? "Activer le mode clair" : "Activer le mode sombre"}
            >
                {theme === "dark" ? "☀ Mode clair" : "☾ Mode sombre"}
            </button>
            <h1>Connexion</h1>

            <form className="login-form" onSubmit={handleSubmit}>
                <input
                    type="text"
                    placeholder="Nom d’utilisateur"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />

                <input
                    type="password"
                    placeholder="Mot de passe"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />

                {error && <div className="error">{error}</div>}

                <button type="submit">Se connecter</button>
            </form>
        </div>
    );
}
